import { Pipe, PipeTransform } from '@angular/core'
import { Image } from '@parkupp/core'

@Pipe({ name: 'sortImagesByPrimaryImage' })
export class SortImagesByPrimaryImagePipe implements PipeTransform {
    transform(value: Image[], imagePrimary: string, imagesByKey?: { [id: string]: Image }): Image[] {
        return SortImagesByPrimaryImagePipe.sortImages(value, imagePrimary, imagesByKey)
    }

    /**
     * imagePrimary is the image key in parking.images (merchant editor) or a legacy originalUrl.
     * Pass the parking's images map so a key can be resolved to its URL.
     */
    static sortImages(images: Image[], imagePrimary: string, imagesByKey?: { [id: string]: Image }): Image[] {
        const first = SortImagesByPrimaryImagePipe.primaryImageUrl(imagePrimary, imagesByKey)
        if (!first) return images
        return images.sort((a, b) => (a.originalUrl == first ? -1 : b.originalUrl == first ? 1 : 0))
    }

    static primaryImageUrl(imagePrimary: string | undefined, imagesByKey?: { [id: string]: Image }): string {
        if (!imagePrimary) return ''
        if (imagesByKey && imagesByKey[imagePrimary]) return imagesByKey[imagePrimary].originalUrl || ''
        return imagePrimary
    }

    /**
     * Display URL for a parking's primary image, falling back to the first image
     */
    static primaryImageDisplayUrl(imagePrimary: string | undefined, imagesByKey?: { [id: string]: Image }): string {
        const images = Object.values(imagesByKey || {})
        const primaryUrl = SortImagesByPrimaryImagePipe.primaryImageUrl(imagePrimary, imagesByKey)
        const image = images.find((i) => i.originalUrl == primaryUrl) || images[0]
        if (!image) return ''
        return image.largeUrl || image.mediumUrl || image.smallUrl || image.originalUrl || ''
    }
}
